import script from "./SingleFight.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./SingleFight.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleFight.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./SingleFight.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__